import { ArrowUp2 } from 'iconsax-react';
import { useTranslation } from 'react-i18next';

type Props = {
  onClick: () => void;
  count: number;
};

export default function ScrollToLastReadButton({ count, onClick }: Props) {
  const { t } = useTranslation();

  const shouldShow = count <= Number.MAX_SAFE_INTEGER && count > 50;

  return (
    shouldShow && (
      <div className='flex items-center justify-center fixed bottom-safe-offset-20 left-1/2 -translate-x-1/2'>
        <button
          type='button'
          className='z-40 m-2 flex h-10 min-w-10 items-center justify-center gap-1.5 rounded-full bg-neutral-0 px-5 text-sm text-primary shadow-lg select-none'
          onClick={onClick}>
          <ArrowUp2 className='size-4' />

          {t('conversation.message.unread', { count })}
        </button>
      </div>
    )
  );
}
